import { createFileRoute } from '@tanstack/react-router';

import { PlanSettingsTab, QueryBoundary } from '../../../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <QueryBoundary>
      <PlanSettingsTab planId={params.planId} />
    </QueryBoundary>
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/settings'
)({
  component: Page
});
